export enum InputValidationErrorMessageEnum {
  FIELD_REQUIRED = 'This field is required.'
}
